import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	token: null,
	userId: null,
	error: null,
	loading: false,
	authSuccessRedirect: '/',
};

const authStart = (state, action) => {
	return updateObject(state, { loading: true, error: null });
};

const authSuccess = (state, action) => {
	return updateObject(state, {
		token: action.idToken,
		userId: action.userId,
		loading: false,
		error: null,
	});
};

const authError = (state, action) => {
	return updateObject(state, { error: action.error, loading: false });
};

const authLogout = (state, action) => {
	return updateObject(state, { token: null, userId: null, authSuccessRedirect: '/' });
};

const setAuthRedirectPath = (state, action) => {
	return updateObject(state, { authSuccessRedirect: action.path });
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.AUTH_START:
			return authStart(state, action);
		case actionTypes.AUTH_SUCCESS:
			return authSuccess(state, action);
		case actionTypes.AUTH_ERROR:
			return authError(state, action);
		case actionTypes.AUTH_LOGOUT:
			return authLogout(state, action);
		case actionTypes.SET_AUTH_REDIRECT_PATH:
			return setAuthRedirectPath(state, action);
		default:
			return state;
	}
};

export default reducer;
